import React from "react";
import IconBase, { IconBaseProps } from "./IconBase";

const IconInsurance: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 22"
      {...props}
    >
      <path
        d="M10.084 0.882812L18.5615 4.14453L19.043 4.3291V12.8057C19.0429 15.2857 17.3693 17.2496 15.5088 18.6465C13.7282 19.9832 11.6262 20.9141 10.1357 21.4014L10.1113 21.4834C10.0745 21.4721 10.0377 21.4582 10 21.4463C9.96237 21.4582 9.92542 21.4721 9.88867 21.4834L9.86328 21.4014C8.37286 20.914 6.27153 19.983 4.49121 18.6465C2.63067 17.2496 0.957145 15.2858 0.957031 12.8057V4.3291L1.43848 4.14453L9.91504 0.882812L9.9375 0.827148L10 0.850586L10.0625 0.827148L10.084 0.882812ZM2.45703 5.35938V12.8057C2.45715 14.5711 3.65892 16.1464 5.3916 17.4473C6.88696 18.5699 8.65862 19.3935 10 19.8662C11.3413 19.3935 13.1131 18.5698 14.6084 17.4473C16.341 16.1464 17.5429 14.571 17.543 12.8057V5.35938L10 2.45801L2.45703 5.35938ZM14.8164 6.66504C15.1294 6.39432 15.6029 6.42874 15.874 6.74121C16.145 7.05439 16.111 7.52874 15.7979 7.7998L8.13184 14.4336L7.6543 14.8467L7.16602 14.4473L4.21777 12.0352C3.89743 11.7728 3.85008 11.3 4.1123 10.9795C4.37454 10.6593 4.8465 10.6121 5.16699 10.874L7.62695 12.8857L14.8164 6.66504Z"
        fill={color}
        stroke={color}
        strokeWidth="0.4"
      />
    </IconBase>
  );
};

export default IconInsurance;
